<template>
    <div id="c">
        <header class="lmy-header lmy-header-w">
            <i class="iconfont icon-back" onclick="window.history.go(-1)"></i>
            详情设施
        </header>
        <div class="lmy-hotel-detail">
            <ul class="filter-bar">
                <li :class="filterBarNum == 0?'active':'' " @click="positionFn(0)"><span>酒店介绍</span></li>
                <li :class="filterBarNum == 1?'active':'' " @click="positionFn(1)"><span>设施政策</span></li>
                <li :class="filterBarNum == 2?'active':'' " @click="positionFn(2)"><span>酒店政策</span></li>
                <li :class="filterBarNum == 3?'active':'' " @click="positionFn(3)"><span>交通和周边</span></li>
            </ul>
            <!-- 酒店介绍 -->
            <div class="detail-content">
                <div class="title">酒店介绍</div>
                <!-- <p class="info">2015年开业，2018年最新装修。</p> -->
                <!-- <p class="info">{{details.BuildOn?(details.BuildOn.split('-')[0])+'年开业':''}}  {{details.LastDecorationOn?(details.LastDecorationOn.split('-')[0])+'年装修':''}}</p> -->
                <p class="info">{{details.SellingPoint}}</p>
                <p class="info" v-html="details.Intro"></p>
            </div>
            <div class="detail-content" id="facilities">
                <div class="title">设施服务</div>

                <div  v-for="(fcGroup,key) in details.FacilitesByGroup" >
                    <h5 class="sub-title">{{key}}</h5>
                    <ul class="facility-list">
                        <li v-for="eqmt in fcGroup">
                            <span>{{eqmt}}</span>
                        </li>
                    </ul>
                </div>


            </div>
            <!-- <div class="check-all">查看全部 <i class="iconfont icon-xiala"></i></div> -->
            <!-- 酒店政策 -->
            <div class="detail-content" id="hotelPolicy">
                <div class="title">酒店政策</div>
                <div  class="hotel-view" v-for="(pl,key) in details.Policies">
                    <!-- <h5 class="sub-title">{{key}}</h5> -->
                    <p class="info" v-html="pl"></p>
                </div>

            </div>
            <div class="detail-content" id="traffic">
                <div class="title">交通周边</div>

            </div>

            <!-- 交通和周边 -->
 
            <mapView :mapData="mapData"></mapView>

        </div>

    </div>

</template>
<script>
    import eqmtList from './../common/equitment.js'
    import mapView from './../common/cmpnt/mapView.vue'//地图
    export default{
        name:'hotel-readme',
        components:{
            mapView
        },
        data(){
            return{
                details:JSON.parse(this.dao.get('frhotelReadmeView')),
                eqmtList:eqmtList,
                filterBarNum: 0,
                mapData:{
                    lat:  Number(JSON.parse(this.dao.get('frhotelReadmeView')).Lat),
                    lng:  Number(JSON.parse(this.dao.get('frhotelReadmeView')).Lon),
                    m1:   Number(JSON.parse(this.dao.get('frhotelReadmeView')).Lon),
                    m2:   Number(JSON.parse(this.dao.get('frhotelReadmeView')).Lat),
                    from: 0,
                }
            }
        },
      methods:{
        positionFn (num) {
          var ss = document.getElementById('facilities');
          var tr = document.getElementById('traffic');
          var hp = document.getElementById('hotelPolicy');
          var bar = document.getElementsByClassName('filter-bar')
          var head = document.getElementsByTagName('header');
          // var html = document.getElementsByTagName('html');
          switch(num){
            case 0:
              window.scrollTo(0,0);
              this.filterBarNum = 0;
              break;
            case 1:
              window.scrollTo(0,ss.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
              this.filterBarNum = 1;
              break;
            case 2:
              window.scrollTo(0,hp.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
              this.filterBarNum = 2;
              break;
            case 3:
              window.scrollTo(0,tr.offsetTop - head[0].offsetHeight - bar[0].offsetHeight);
              this.filterBarNum = 3;
              break;
          }
        }
      }
    }

</script>



// WEBPACK FOOTER //
// src/components/frHotel/view.vue